import { LoadablePaint } from '@confluence/loadable';
import { MustPreloadLoadableNames } from '@confluence/loadable';

export const ViewPageLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ViewPage" */ '../src/ViewPage')).ViewPage,
	_mustPreloadWhenRenderingSPA: [MustPreloadLoadableNames.ViewPageRouteComponentLoader],
});
